import React, { useState, useEffect } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'
import ApiEndpoints from './commonComponents/ApiEndpoints'
import toast from 'react-hot-toast'

const resolveAttendantIdFromBus = (b) => {
  if (!b) return ''
  const raw =
    b.bus_attendant_id ??
    b.vehicle_attendant_id ??
    b.attendant_id ??
    (b.attendant && (b.attendant.id ?? b.attendant.user_id)) ??
    ''
  return raw === null || raw === undefined ? '' : String(raw)
}

const EditBusModal = ({ show, handleClose, bus, onUpdate }) => {
  const [attendants, setAttendants] = useState([])
  const [updatedBus, setUpdatedBus] = useState({
    bus_number: '',
    driver_name: '',
    driver_contact_number: '',
    bus_owner_name: '',
    bus_attendant_id: '',
  })

  useEffect(() => {
    if (!show) return
    let cancelled = false
    const loadAttendants = async () => {
      try {
        const res = await ApiEndpoints.getBusAttendants()
        const list = res.data?.data ?? res.data ?? []
        if (!cancelled) setAttendants(Array.isArray(list) ? list : [])
      } catch (error) {
        if (!cancelled) {
          setAttendants([])
          toast.error(
            error?.response?.data?.message ||
              'Could not load vehicle attendants'
          )
        }
      }
    }
    loadAttendants()
    return () => {
      cancelled = true
    }
  }, [show])

  useEffect(() => {
    if (bus) {
      setUpdatedBus({
        bus_number: bus.bus_number || '',
        driver_name: bus.driver_name || '',
        driver_contact_number: bus.driver_contact_number || '',
        bus_owner_name: bus.bus_owner_name || '',
        bus_attendant_id: resolveAttendantIdFromBus(bus),
      })
    }
  }, [bus])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setUpdatedBus((prev) => ({ ...prev, [name]: value }))
  }

  const handleSaveChanges = async () => {
    try {
      const payload = {
        ...updatedBus,
        bus_attendant_id:
          updatedBus.bus_attendant_id === '' ||
          updatedBus.bus_attendant_id === undefined
            ? null
            : Number(updatedBus.bus_attendant_id),
      }
      const response = await ApiEndpoints.updateBus(bus.bus_id, payload)

      toast.success(
        response?.data?.message || 'Vehicle updated successfully'
      )

      onUpdate(payload)
      handleClose()
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          'Something went wrong'
      )
    }
  }

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header
        closeButton
        className="text-dark"
        style={{ backgroundColor: '#BDE0FE' }}
      >
        <Modal.Title>Edit Vehicle</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Vehicel Number</Form.Label>
            <Form.Control
              type="text"
              name="bus_number"
              value={updatedBus.bus_number}
              onChange={handleInputChange}
              placeholder="Enter Vehicel Number"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Driver Name</Form.Label>
            <Form.Control
              type="text"
              name="driver_name"
              value={updatedBus.driver_name}
              onChange={handleInputChange}
              placeholder="Enter Driver Name"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Driver Number</Form.Label>
            <Form.Control
              type="text"
              name="driver_contact_number"
              value={updatedBus.driver_contact_number}
              onChange={handleInputChange}
              placeholder="Enter Driver Number"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Owner Name</Form.Label>
            <Form.Control
              type="text"
              name="bus_owner_name"
              value={updatedBus.bus_owner_name}
              onChange={handleInputChange}
              placeholder="Enter Owner Name"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Select vehicle attendant</Form.Label>
            <Form.Select
              name="bus_attendant_id"
              value={updatedBus.bus_attendant_id}
              onChange={handleInputChange}
            >
              <option value="">— None —</option>
              {attendants
                .filter((a) => a.id != null || a.user_id != null)
                .map((a) => {
                  const id = a.id ?? a.user_id
                  const label =
                    a.name ||
                    [a.first_name, a.last_name].filter(Boolean).join(' ') ||
                    a.email ||
                    `User #${id}`
                  return (
                    <option key={id} value={String(id)}>
                      {label}
                    </option>
                  )
                })}
            </Form.Select>
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>

        <Button variant="success" onClick={handleSaveChanges}>
          Update
        </Button>
      </Modal.Footer>
    </Modal>
    
  )
}

export default EditBusModal